import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { getCATCursos } from '../../app/models/CATCursos';
import { Botonera } from '../Portafolio/helpers/botonera';
import { useStore } from "../../app/stores/store";
import { AnchorTabsCursos } from "../Portafolio/Handlers/AnchorTabs";
import { BuscadorComponent } from "../Portafolio/BuscadorCursos/BuscadorComponent";
import { calculoFechas } from "../Portafolio/helpers/calculoFechas";
import banner from "../../images/cursos_diplomados.jpg";
import curDiplo from "../Portafolio/src/imgs/page_headers/diplomados.png";
import Footer from "../Footer";
import icon_person from '../Portafolio/src/imgs/person_icon.svg';
import icon_teacher from '../Portafolio/src/imgs/teacher_icon.svg';
import icon_calendar from '../Portafolio/src/imgs/calendar_icon.svg';
import icon_location from '../Portafolio/src/imgs/pinpoint_icon.svg';
import { RegionalBannerCentral } from '../Portafolio/Handlers/RegionalBannerCentral';
import { AnchorTabsCategories } from "../Portafolio/Handlers/AnchorTabsCategories";
import { FiltroCardsCertificados, FiltroCardsCursos } from "../Portafolio/Handlers/FiltroCursos";
import { nombreDelegacion } from '../Portafolio/helpers/nombreDelegacion';
import { Container } from "semantic-ui-react";
import { myBreadCrumbs2L } from '../Portafolio/Handlers/Breadcrumbs';

export default observer(function Cursos() {

  const { userStore: { user, logout, isLoggedIn } } = useStore();
  const { CATCursosStore } = useStore();
  const { loadCATCursosByDir, CATCursosRegistry, getCATCursosByCodigo, loadCATCursosByLevel } = CATCursosStore;

  useEffect(() => {
    if (CATCursosRegistry.size <= 1) {
      loadCATCursosByLevel("10", "1");
      loadCATCursosByLevel("14", "1");
      loadCATCursosByLevel("15", "1");
      loadCATCursosByLevel("16", "1");
      loadCATCursosByLevel("144", "2");
      loadCATCursosByLevel("155", "2");
      loadCATCursosByLevel("166", "2");
      loadCATCursosByLevel("1111", "4");
      loadCATCursosByLevel("1222", "4");
      loadCATCursosByLevel("1333", "4");
    }
  }, [CATCursosRegistry.size, loadCATCursosByLevel]);

  if (CATCursosStore.loadingInitial)

    return <LoadingComponent content="Cargando datos.." />;
  return (
    <>
      {/* <RegionalBannerCentral /> */}
      <div className="regional-title">
        <div className="regional-block-title"></div>
        <h3>INAP - Cursos y Diplomados</h3>
      </div>
      <div className="regional-head-area container-fluid"></div>
      <style>{`
        .regional-head-area {
          background-image: url(${curDiplo});
          background-size: cover;
          background-position: center top;
          background-repeat: no-repeat;
          width: 100%;
          position: relative;
          background-color: #f5f5f5;
        }       
        @media (max-width: 549px) {
          .regional-head-area {
            height: 90px;
            background-size: contain;
          }
          .regional-title h3 {
            font-size: 16px;
          }
        }
        @media (min-width: 550px) and (max-width: 767px) {
          .regional-head-area {
            height: 130px;
             background-size: contain;
          }
          .regional-title h3 {
            font-size: 18px;
          }
        }
        @media (min-width: 768px) and (max-width: 991px) {
          .regional-head-area {
            height: 170px;
             background-size: contain;
          }
          .regional-title h3 {
            font-size: 20px;
          }
        }
        @media (min-width: 992px) and (max-width: 1199px) {
          .regional-head-area {
            height: 215px;
             background-size: contain;
          }
          .regional-title h3 {
            font-size: 22px;
          }
        }
        @media (min-width: 1200px) and (max-width: 1990px) {
          .regional-head-area {
            height: 250px;
             background-size: contain;
          }
          .regional-title h3 {
            font-size: 24px;
          }
        }
        @media (min-width: 1491px) {
          .regional-head-area {
            height: 260px;
            width: 100%;
          }
          .regional-title h3 {
            font-size: 26px;
          }
        }
      `}</style>

      <AnchorTabsCategories />

      {/* <div className="banner_area container-fluid">
        <div className="banner_top">
          <img src={banner}></img>
        </div>
      </div> */}

      < AnchorTabsCursos />
      <div className="portafolio_phome_area catalogo_servicios">
        <div className="portafolio_header">
          {myBreadCrumbs2L("Cursos y Diplomados")}
          <Botonera />
          <FiltroCardsCursos />
          <div className="buscador_area">
            <BuscadorComponent />
          </div>
        </div>

        <div id="hw_search" className="portafolio_htexto">
          <p>
            Desarrollar competencias en los participantes para atender las necesidades relativas a la gestión por resultados, involucrando el desarrollo de la capacidad de análisis, el uso de la información para la toma de decisiones dentro de un sistema de gestión establecido que responda al manejo de las metodologías e instrumentos de presupuestos por resultados.
          </p>
        </div>             

        <div id="section0" className="portafolio_subcat first_section">
          <h2>Cursos Presenciales</h2>
        </div>
        <div id="hw_search" className="portafolio_htexto">
          <p>Los cursos presenciales de INAP, están diseñados para capacitar a los servidores y funcionarios públicos en los principios y prácticas de la gestión gubernamental.  A través de sesiones interactivas, se abordan temas diversos que tienen como objetivo generar las competencias necesarias para que los participantes generen valor público desde su Institución.  Los asistentes participan en debates, estudios de caso y simulaciones que les permiten aplicar conceptos teóricos a situaciones reales, mejorando sus habilidades para enfrentar los dasafíos del sector público y contribuir al desarrollo institucional.</p>
        </div>
        <div id="hw_search" className="portafolio_content">
          {CATCursosStore.getCATCursosByLevel.map((item: getCATCursos) => {
            const url = `/asesoria/${item.id}/${user?.id}`,
              startDateFrom = new Date(item.editions?.fechaDeInicioInscripcion);
            if (
              item.nivel == "10" && item.editions?.is_active === true              
            ) {
              return (
                <div className="portafolio_card" id={item.nivel} key={item.id}>

                  <Link to={url}>

                    <div className="pcard_imagen"> <img src={item.imageUrl} alt={item.nombre} /></div>
                    <div className="pcard_tipoc"> <p className="mod_card_basica">{item.modalidad}</p></div>

                    <div className="pcard_contenido_publico">
                      <div className="pcard_edicion">
                        <p>Edición en curso {item.editions?.numeroEdicion}</p>
                      </div>

                      <div className="pcard_titulo_curso">
                        <p className='titulo_curso' id='titulo_curso'>{item.nombre}</p>
                      </div>

                      <div className="card_info_curso">
                        <div className="pcard_estudiantes">
                          <img src={icon_person} />
                          <p>Inicio de inscripciones</p>
                        </div>
                        <div className="pcard_fecha">
                          <img src={icon_calendar} />
                          <p> {calculoFechas(startDateFrom)} </p>
                        </div>
                      </div>

                      <div className="pcard_docentes">
                        <img src={icon_location} />
                        <p>Sede: {nombreDelegacion(item?.nivel)}</p>
                      </div>

                    </div>

                    <div className="pcard_linea"><span></span></div>

                  </Link>

                </div>

              );
            }
          })}

</div>

       <div id="section1" className="portafolio_subcat first_section">
          <h2>Cursos m-Learning</h2>
        </div>
        <div id="hw_search" className="portafolio_htexto">
          <p>El INAP atendiendo al llamado de la innovación en la prestación de sus servicios ha implementado el uso de la modalidad MOOC (Cursos online masivos y abiertos), en los procesos de capacitación en línea, los cuales son flexibles haciendo uso de la Tecnología móvil. <br /> Los cursos MOOC, están diseñados para proveer técnicas y herramientas en el corto plazo que permitirán al servidor público utilizarlas para atender y resolver problemas institucionales, que requieren atención inmediata.</p>
        </div>
        <div id="hw_search" className="portafolio_content">
          {CATCursosStore.getCATCursosByLevel.map((item: getCATCursos) => {
            const url = `/asesoria/${item.id}/${user?.id}`,
              startDateFrom = new Date(item.editions?.fechaDeInicioInscripcion);
            if (
              item.nivel == "14" && item.editions?.is_active === true ||
              item.nivel == "144" && item.editions?.is_active === true ||
              item.nivel == "1444" && item.editions?.is_active === true
            ) {
              return (
                <div className="portafolio_card" id={item.nivel} key={item.id}>

                  <Link to={url}>

                    <div className="pcard_imagen"> <img src={item.imageUrl} alt={item.nombre} /></div>
                    <div className="pcard_tipoc"> <p className="mod_card_basica">{item.modalidad}</p></div>

                    <div className="pcard_contenido_publico">
                      <div className="pcard_edicion">
                        <p>Edición en curso {item.editions?.numeroEdicion}</p>
                      </div>

                      <div className="pcard_titulo_curso">
                        <p className='titulo_curso' id='titulo_curso'>{item.nombre}</p>
                      </div>

                      <div className="card_info_curso">
                        <div className="pcard_estudiantes">
                          <img src={icon_person} />
                          <p>Inicio de inscripciones</p>
                        </div>
                        <div className="pcard_fecha">
                          <img src={icon_calendar} />
                          <p> {calculoFechas(startDateFrom)} </p>
                        </div>
                      </div>

                      <div className="pcard_docentes">
                        <img src={icon_location} />
                        <p>Sede: {nombreDelegacion(item?.nivel)}</p>
                      </div>

                    </div>

                    <div className="pcard_linea"><span></span></div>

                  </Link>

                </div>

              );
            }
          })}


        </div>

        <div id="section2" className="portafolio_subcat second_section">
          <h2>Cursos e-Learning</h2>
        </div>
        <div id="hw_search" className="portafolio_htexto">
          <p>Los cursos virtuales del INAP, buscan fortalecer en las instituciones las capacidades y competencias del servidor público, en la aplicación práctica que demande su puesto de Trabajo, para gestionar de forma eficiente los recursos públicos.<br /> En efecto, los cursos virtuales, utilizan para su formación herramientas o aplicaciones tecnológicas como: correo electrónico, foros de discusión, mensajería instantánea, páginas web, plataformas de comunicación, etc.</p>
        </div>

        <div id="hw_search" className="portafolio_content">

          {CATCursosStore.getCATCursosByLevel.map((item: getCATCursos) => {

            const url = `/asesoria/${item.id}/${user?.id}`,
              startDateFrom = new Date(item.editions?.fechaDeInicioInscripcion);

            if (
              item.nivel == "15" && item.editions?.is_active === true ||
              item.nivel == "155" && item.editions?.is_active === true ||
              item.nivel == "1555" && item.editions?.is_active === true
            ) {
              return (

                <div className="portafolio_card" id={item.nivel} key={item.id}>

                  <Link to={url}>

                    <div className="pcard_imagen"> <img src={item.imageUrl} alt={item.nombre} /></div>
                    <div className="pcard_tipoc"> <p className="mod_card_intermedia">{item.modalidad}</p></div>
                    <div className="pcard_contenido_publico">
                      <div className="pcard_edicion">
                        <p>Edición en curso {item.editions?.numeroEdicion}</p>
                      </div>
                      <div className="pcard_titulo_curso">
                        <p className='titulo_curso' id='titulo_curso'>{item.nombre}</p>
                      </div>
                      <div className="card_info_curso">
                        <div className="pcard_estudiantes">
                          <img src={icon_person} />
                          <p>Inicio de inscripciones</p>
                        </div>
                        <div className="pcard_fecha">
                          <img src={icon_calendar} />
                          <p> {calculoFechas(startDateFrom)} </p>
                        </div>
                      </div>
                      <div className="pcard_docentes">
                        <img src={icon_location} />
                        <p>Sede: {nombreDelegacion(item?.nivel)}</p>
                      </div>
                    </div>
                    <div className="pcard_linea"><span></span></div>
                  </Link>
                </div>
              );
            }
          })}

        </div>
        <div id="section3" className="portafolio_subcat second_section">
          <h2>Diplomados</h2>
        </div>
        <div id="hw_search" className="portafolio_htexto">
          <p>Los diplomados del INAP responden a las tendencias actuales del modelo andragógico, dirigidos al nivel estratégico y táctico de las instituciones públicas, con el objetivo de dotar competencias, técnicas y herramientas a los participantes en la producción de bienes y servicios de manera eficaz y eficiente.</p>
        </div>
        <div id="hw_search" className="portafolio_content">
          {CATCursosStore.getCATCursosByLevel.map((item: getCATCursos) => {
            const url = `/asesoria/${item.id}/${user?.id}`,
              startDateFrom = new Date(item.editions?.fechaDeInicioInscripcion);
            if (
              item.nivel == "16" && item.editions?.is_active === true ||
              item.nivel == "166" && item.editions?.is_active === true ||
              item.nivel == "1666" && item.editions?.is_active === true
            ) {
              return (
                <div className="portafolio_card" id={item.nivel} key={item.id}>
                  <Link to={url}>
                    <div className="pcard_imagen"> <img src={item.imageUrl} alt={item.nombre} /></div>
                    <div className="pcard_tipoc"> <p className="mod_card_avanzada">{item.modalidad}</p></div>

                    <div className="pcard_contenido_publico">
                      <div className="pcard_edicion">
                        <p>Edición en curso {item.editions?.numeroEdicion}</p>
                      </div>

                      <div className="pcard_titulo_curso">
                        <p className='titulo_curso' id='titulo_curso'>{item.nombre}</p>
                      </div>
                      <div className="card_info_curso">
                        <div className="pcard_estudiantes">
                          <img src={icon_person} />
                          <p>Inicio de inscripciones</p>
                        </div>
                        <div className="pcard_fecha">
                          <img src={icon_calendar} />
                          <p> {calculoFechas(startDateFrom)} </p>
                        </div>
                      </div>
                      <div className="pcard_docentes">
                        <img src={icon_location} />
                        <p>Sede: {nombreDelegacion(item?.nivel)}</p>
                        </div>
                    </div>
                    <div className="pcard_linea"><span></span></div>
                  </Link>
                </div>
              );
            }
          })}
        </div>
      </div>
      <Footer />
    </>
  );
});
